'use client';

import { useAuthenticationModalStore } from '@/core/stores/auth';
import { useUserStore } from '@/core/stores/user';
import useNextRouter from '@/hooks/useNextRouter';
import { MouseEvent } from 'react';

interface LoginProtectorProps {
  navigateTo: string;
  className?: string;
  withPrefetch?: boolean;
  children?: React.ReactNode;
}

const LoginProtector = ({
  navigateTo,
  className = '',
  withPrefetch = false,
  children,
}: LoginProtectorProps) => {
  const { _id } = useUserStore();
  const { setShowAuthModal } = useAuthenticationModalStore();
  const { push, prefetch } = useNextRouter();

  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();

    const isLoggedIn = Boolean(_id);

    if (!isLoggedIn) {
      setShowAuthModal(true);
      return;
    }

    push(navigateTo);
    if (withPrefetch) {
      prefetch(navigateTo);
    }
  };

  return (
    <button onClick={handleClick} className={className} type="button">
      {children}
    </button>
  );
};

export default LoginProtector;
